import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.mensagem
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-alert", {
                    attrs: {
                      message: _vm.mensagem,
                      icon: "info",
                      type: "info",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.dispensas.length > 0
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-title", {
                    attrs: { texto: "MOTIVOS DE DISPENSA DO DIAGNÓSTICO" },
                  }),
                  _c(VDataTable, {
                    attrs: { headers: _vm.headers, items: _vm.dispensas },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }